<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" :model="filters" size="small">
    <!-- <el-form-item class="select_btn_160">
      <el-select
        class="select_btn_style"
        v-model="filters.healthReportStatus"
        placeholder="健康申报状态"
      >
        <el-option
          v-for="(item, i) in healthReportStatusList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item> -->
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.groupId"
        placeholder="分组名称"
      >
        <el-option
          v-for="(item, i) in groupNameList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.clockStatus"
        placeholder="报到状态"
      >
        <el-option
          v-for="(item, i) in clockStatusList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.userName"
        placeholder="姓名"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" :title="'查询'" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>

<script>
import butn from "@/components/button/index";
import { getSysParamByTypes } from "@/api/sysParam";

export default {
  components: {
    butn,
  },
  props: {
    groupNameList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      filters: {},
      healthReportStatusList: [],
      clockStatusList: [],
    };
  },
  created() {
    this.getSysParamByTypes(["HEALTH_REPORT_STATUS", "CLOCK_STATUS"]);
  },
  methods: {
    
    
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({types: types}).then((res) => {
        if (!res || res.code != 0) return;
        res.data["HEALTH_REPORT_STATUS"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        res.data["CLOCK_STATUS"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        this.healthReportStatusList = res.data["HEALTH_REPORT_STATUS"] || [];
        this.clockStatusList = res.data["CLOCK_STATUS"] || [];
      });
    },

    setGroupId(groupId) {
      this.filters = {
        ...this.filters,
        groupId: groupId,
      }
      this.initData();
    },

    initData() {
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
    resetData() {
      this.filters = {};
      this.$emit("search", { t: new Date().getTime() });
    },
  },
};
</script>
